import { IconButton, InputBase, Paper } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Col, Form, Row, Image, Table, Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import SearchIcon from "@material-ui/icons/Search";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import {
  vendor_get_all_debit_credit_memo,
  vendor_get_memo_id,
} from "../../../store/actions/OrderingAction/vendorOrderingAction";
import moment from "moment";
import { VIEW_MEMO_DETAILS } from "../../../store/types";
import isEmpty from "../../../store/validation/is-Empty";
import SelectFilter from "../../reusableComponents/selectFilter";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import Media from "react-media";
import NoContent from "../../reusableComponents/NoContentComponent";

const onSuccess = () => { };

const memoFilter = {
  status: [
    { value: "PAID", name: "Paid" },
    { value: "PENDING", name: "Pending" },
  ],
  type: [
    { value: "DEBIT", name: "Debit Memo" },
    { value: "CREDIT", name: "Credit Memo" },
  ],
};
const Memoslist = (props) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  let filteredData = useSelector((state) => {
    return !isEmpty(state.vendorOrdering?.all_debit_creit_memo)
      ? state.vendorOrdering?.all_debit_creit_memo
      : [];
  });

  const [dateQuery, setDateQuery] = useState({});

  // Filter Data

  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    status: "",
    type: "",
    search: false,
  });

  const userFilter = [
    { title: "Order Date", disabled: true },
    { title: "Date & Time 🠑", disabled: false },
    { title: "Date & Time 🠓", disabled: false },
    { title: "Amount", disabled: true },
    { title: `Low to High 🠑`, disabled: false },
    { title: "High to Low 🠓", disabled: false },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  if (sort === "Date & Time 🠑") {
    filteredData = filteredData.sort(
      (a, b) =>
        new Date(a.order_id?.createdAt) - new Date(b.order_id?.createdAt)
    );
  } else if (sort === "Date & Time 🠓") {
    filteredData = filteredData.sort(
      (a, b) =>
        new Date(b.order_id?.createdAt) - new Date(a.order_id?.createdAt)
    );
  } else if (sort === "Low to High 🠑") {
    filteredData = filteredData.sort(
      (a, b) =>
        Number.parseFloat(a.refund_amount).toFixed(2) -
        Number.parseFloat(b?.refund_amount).toFixed(2)
    );
  } else if (sort === "High to Low 🠓") {
    filteredData = filteredData.sort(
      (a, b) =>
        Number.parseFloat(b?.refund_amount).toFixed(2) -
        Number.parseFloat(a?.refund_amount).toFixed(2)
    );
  }

  if (filter.search) {
    if (filter.type)
      filteredData = filteredData.filter((item) => {
        return item?.memo_type == filter?.type;
      });
    if (filter.status)
      filteredData = filteredData.filter((item) => {
        return item?.payment_status == filter?.status;
      });
  }

  if (search) {
    filteredData = filteredData.filter((item) => {
      return (
        item?.order_id?.order_id.toLowerCase().includes(search.toLowerCase()) ||
        item?.order_id?.user_details?.first_name
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    });
  }

  // const downloadData = {
  //   headers: [
  //     { label: "Restaurant Name", key: "name" },
  //     { label: "ID", key: "id" },
  //     { label: "Tip Amount", key: "tip" },
  //     { label: "Order Amount", key: "order" },
  //     { label: "Event Amount", key: "event" },
  //     { label: "Scan Amount", key: "scan" },
  //     { label: "Total Amount", key: "total" },
  //   ],
  //   data: filteredData ? filteredData?.map((ele) => {
  //     return {
  //       "name": ele?.restaurant_name,
  //       "id": ele?._id,
  //       "tip": ele?.orderTipAmount.toFixed(2),
  //       "order": ele?.orderPayAmount.toFixed(2),
  //       "event": ele?.eventPayAmount.toFixed(2),
  //       "scan": ele?.scanAndPayPayAmount.toFixed(2),
  //       "total": (ele?.orderTipAmount + ele?.orderPayAmount + ele?.eventPayAmount + ele?.scanAndPayPayAmount).toFixed(2),
  //     };
  //   }) : [],
  // };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      const token = auth.accessToken;
      let query = { memoType: "all", ...dateQuery };
      dispatch(vendor_get_all_debit_credit_memo(token, query, onSuccess));
    }
  }, [dateQuery]);

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
              <div className="f24_700_HelveticaNeue">Memos</div>
              <NavLink to="/addmemo" className="btn btn-danger btn2 btn-lg">
                + Add Memo
              </NavLink>
            </div>
            <Row className="align-items-center mobile-m-0">
              <Col md={7} xs={12}>
                <div className="row super-admin-toptext-searchbar-icon">
                  <div className="col-md-6 col-12">
                    <div className="col-12 p-0">
                      <Form.Control
                        type="text"
                        placeholder="Search"
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                        className="amSearch w-100"
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={3} xs={12} className="mobile-mt-2">
                <SelectFilter onDateChange={onDateChangeHandler()} />
              </Col>

              <div className="col-12 col-md-2">
                <div className="d-flex align-items-center justify-content-between m-justify-content-end">
                  <div
                    className="f10-400 mr-2"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    <img
                      src={require("../../../assets/images/iconButton/sorticon.png")}
                      width="35px"
                    />
                    <br />
                    Sort
                  </div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {userFilter.map((ele, index) => {
                      return (
                        <MenuItem
                          value={ele.title}
                          key={index}
                          onClick={() => setSort(ele.title)}
                          disabled={ele.disabled}
                        >
                          {ele.title}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                  <div className="f10-400" align="center">
                    <img
                      src={require("../../../assets/images/iconButton/filtericon.png")}
                      width="35px"
                      alt="Filter Icon"
                      onClick={() => setShowFilter(!showFilter)}
                    />
                    <br />
                    Filter
                  </div>
                  {/* <CSVDownloader
                        filename={"settlement"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      /> */}
                </div>
              </div>
              <Modal
                show={showFilter}
                onHide={() => setShowFilter(!showFilter)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <FormTemp
                    showFilter={showFilter}
                    setShowFilter={setShowFilter}
                    filter={filter}
                    setStatus={(e) => setFilter({ ...filter, status: e })}
                    setType={(e) => setFilter({ ...filter, type: e })}
                    onSubmit={() => {
                      setFilter({ ...filter, search: true });
                      setShowFilter(!showFilter);
                    }}
                    resetFilter={() => {
                      setFilter({
                        ...filter,
                        status: "",
                        type: "",
                        search: true,
                      });
                    }}
                  // onSubmit={(e) => setFilter({ ...filter, status: e })}
                  />
                </Modal.Body>
              </Modal>
              {/* {showFilter && (
                <div
                  className="container-fluid p-4"
                  style={{
                    backgroundColor: "#ffffff",
                    transition: "height 2s",
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-pmethod">
                            Status
                          </InputLabel>
                          <Select
                            value={filter.status}
                            onChange={(e) =>
                              setFilter({ ...filter, status: e.target.value })
                            }
                            label="Status"
                            inputProps={{
                              name: "pmethod",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {memoFilter.status.map((ele) => (
                              <MenuItem value={ele.value} key={ele.value}>
                                {ele.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Pstatus">
                            Memo Type
                          </InputLabel>
                          <Select
                            value={filter.type}
                            onChange={(e) =>
                              setFilter({ ...filter, type: e.target.value })
                            }
                            label="Memo Type"
                            inputProps={{
                              name: "Pstatus",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {memoFilter.type.map((ele) => (
                              <MenuItem value={ele.value} key={ele.value}>
                                {ele.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="mt-5 d-flex">
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                      title="Cancel Button"
                      onClick={() => {
                        setFilter({
                          location: "",
                          search: false,
                        });
                        setShowFilter(!showFilter);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                      title="Confirm Button"
                      onClick={() => {
                        setFilter({ ...filter, search: true });
                        setShowFilter(!showFilter);
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              )} */}
            </Row>
            <div className="user-table-reusable-superadmin table-responsive">
              <Table>
                <thead>
                  <tr className="super_admin_all_users_table_head">
                    <th style={{ width: "10%" }} className="f12-700">
                      Memo ID
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Transaction <br />
                      ID
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Created On
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Order ID
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Order Date
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      User name
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Status
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Amount
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Doc. <br />
                      Type
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Action
                    </th>
                  </tr>
                </thead>
                {!filteredData ? (
                  <AmealioLoader />
                ) : (
                  <tbody>
                    {filteredData?.length ? filteredData.map((data, index) => {
                      return (
                        <tr
                          key={index}
                          className="super_admin_all_users_table_body"
                          style={{ wordBreak: "break-word" }}
                        >
                          <td colSpan="7" className="p-0 w-100">
                            <table className="w-100 HideShowTable enMinWidth900">
                              <tbody>
                                <tr>
                                  <td style={{ width: "10%" }}>
                                    <div className="f14-500">{data._id}</div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f14-500">
                                      {data.transactional_id || "-"}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {moment(data.createdAt).format(
                                        "DD MMM YYYY , LT"
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data.order_id?.order_id || "-"}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data?.order_id?.createdAt
                                        ? moment(
                                          data?.order_id?.createdAt
                                        ).format("lll")
                                        : "-"}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {`${data?.order_id?.user_details
                                          ?.first_name || ""
                                        } ${data?.order_id?.user_details
                                          ?.last_name || ""
                                        }`}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data?.payment_status === "PAID"
                                        ? "Paid"
                                        : "Pending"}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data.refund_amount}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data.memo_type === "CREDIT"
                                        ? "CM"
                                        : "DM"}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <NavLink to="/viewmemo">
                                      <div
                                        className="f12-400"
                                        style={{
                                          color: "#0077FF",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          dispatch(
                                            vendor_get_memo_id(
                                              auth.accessToken,
                                              data._id,
                                              onSuccess
                                            )
                                          )
                                        }
                                      >
                                        View
                                      </div>
                                    </NavLink>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      );
                    }) : <NoContent />}
                  </tbody>
                )}
              </Table>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Memoslist;

const FormTemp = (props) => {
  const [radio, setRadio] = useState(false);

  return (
    <div className="f12-500">
      <div className="d-flex align-items-center mb-2">
        <div className="mr-2">
          <input
            type="radio"
            name="radio_filter"
            value={radio}
            defaultChecked={true}
            onChange={(e) => {
              setRadio(!radio);
            }}
          />{" "}
          Status
        </div>
        <div>
          <input
            type="radio"
            name="radio_filter"
            value={!radio}
            onChange={(e) => {
              setRadio(!radio);
            }}
          />{" "}
          Memo Type
        </div>
      </div>
      Select one relevent option from below
      <br />
      {radio ? (
        <div className="pt-4 d-flex flex-wrap align-items-center">
          {memoFilter.status.map((ele) => (
            <button
              type="button"
              className={`enFilterButton mr-3 mb-3 ${props.filter.status === ele.value ? "active" : ""
                }`}
              onClick={() => props.setStatus(ele.value)}
            >
              {ele.name}
            </button>
          ))}
        </div>
      ) : (
        <>
          <div className="pt-4 d-flex flex-wrap align-items-center">
            {memoFilter.type.map((ele) => (
              <button
                type="button"
                className={`enFilterButton mr-3 mb-3 ${props.filter.type === ele.value ? "active" : ""
                  }`}
                onClick={() => props.setType(ele.value)}
              >
                {ele.name}
              </button>
            ))}
          </div>
        </>
      )}
      <div className="d-flex justify-content-end mt-2">
        <Button
          className="btn btn-outline-secondary mr-2"
          onClick={() => props.resetFilter()}
        >
          Reset Filter
        </Button>
        <Button className="btn btn-danger" onClick={() => props.onSubmit()}>
          Save Changes
        </Button>
      </div>
    </div>
  );
};
